import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, signal } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { SpinnerComponent } from '@app/components/spinner';
import { LookerSignatureService } from '@app/services/admin-looker/admin-looker.service';
import { Logger } from '@app/services/logger/logger.service';

@Component({
  standalone: true,
  selector: 'app-usage',
  imports: [CommonModule, SpinnerComponent],
  templateUrl: './usage.component.html',
  styleUrls: ['./usage.component.css'],
})
export class UsageComponent implements OnInit {
  private readonly lookerService = inject(LookerSignatureService);
  private readonly sanitizer = inject(DomSanitizer);
  private readonly logger = inject(Logger);
  isLoading = signal(true);
  signedUrl: SafeResourceUrl | null = null;
  onLoadCount = 0;

  ngOnInit(): void {
    this.lookerService.getLookerSignedUrl().subscribe({
      next: (data: { signedUrl: string }) => {
        this.signedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
          data.signedUrl
        );
      },
      error: (error) => {
        this.logger.error(error);
        this.isLoading.set(false);
      },
    });
  }

  onLoad(): void {
    // onLoad() fires 2 times per page load
    this.onLoadCount++;
    if (this.onLoadCount >= 2) {
      this.isLoading.set(false);
    }
  }
}
